import styled from 'styled-components';
import { Card, Text } from '@usealloy/component-library';

export const StyledChangelogCardContainer = styled(Card)`
  &&& {
    border-radius: var(--cl-space-2);
    max-height: 280px;
  }
  > * {
    /* targets the header */
    &:first-child {
      padding: var(--cl-space-2) var(--cl-space-5);
    }

    /* targets the content wrapper */
    &:nth-child(3) {
      overflow-y: scroll;
    }
  }
`;

export const StyledChangelogCardContentWrapper = styled.div<{ isEmpty: boolean }>`
  width: 100%;
  align-self: flex-start;
`;


export const StyledFadedText = styled(Text)`
  &&& {
    color: var(--cl-gray-700);
  }
`;
